import { CoreMenu } from '@core/types';

export const menu: CoreMenu[] = [
	// Home
	{
		id: 'home',
		title: 'Home',
		translate: 'menu_home',
		type: 'item',
		icon: 'home',
		url: 'home',
	},

	// Notifiche
	{
		id: 'my-notifications',
		title: 'Notifiche',
		translate: 'menu_notifications',
		type: 'item',
		icon: 'bell',
		url: 'my-notifications',
	},

	// Federation
	{
		id: 'tenants',
		title: 'Federation',
		translate: 'menu_tenants',
		type: 'item',
		icon: 'building-shield',
		url: 'federation',
		permissions: ['tenants.view'],
	},

	// Vocabolario
	{
		id: 'vocabularies',
		title: 'Vocabolario',
		translate: 'menu_vocabularies',
		type: 'item',
		icon: 'language',
		url: 'vocabularies',
		permissions: ['vocabularies.view'],
	},

	// Corsi
	{
		id: 'courses',
		title: 'Corsi',
		translate: 'menu_courses',
		type: 'collapsible',
		icon: 'school',
		children: [
			{
				id: 'areas',
		title: 'Aree',
		translate: 'menu_areas',
				type: 'item',
				url: 'areas',
				permissions: ['areas.view'],
			},
			{
				id: 'areaClasses',
		title: 'Classi',
		translate: 'menu_area_classes',
				type: 'item',
				url: 'area-classes',
				permissions: ['area_classes.view'],
			},
			{
				id: 'schools',
		title: 'Specializzazioni',
		translate: 'menu_schools',
				type: 'item',
				url: 'schools',
				permissions: ['schools.view'],
			},
		],
	},

	// Università
	{
		id: 'universities',
		title: 'Università',
		translate: 'menu_universities',
		type: 'item',
		icon: 'university',
		url: 'universities',
		permissions: ['universities.view'],
	},

	// Ordinamenti diattici
	{
		id: 'teaching-regulations',
		title: 'Ordinamenti didattici',
		translate: 'menu_teaching_regulations',
		type: 'collapsible',
		icon: 'sitemap',
		children: [
			{
				id: 'training-activity-categories',
		title: 'Tipologie Attività Formative',
		translate: 'menu_training_activity_categories',
				type: 'item',
				url: 'training-activity-categories',
				permissions: ['training_activity_categories.view'],
			},
			{
				id: 'disciplinary-fields',
		title: 'Ambiti Disciplinari',
		translate: 'menu_disciplinary_fields',
				type: 'item',
				url: 'disciplinary-fields',
				permissions: ['disciplinary_fields.view'],
			},
			{
				id: 'sectors',
		title: 'Settori Scientifici Disciplinari',
		translate: 'menu_scientific_sectors',
				type: 'item',
				url: 'scientific-sectors',
				permissions: ['scientific_sectors.view'],
			},
			{
				id: 'alternative-sectors',
		title: 'Settori Alternativi',
		translate: 'menu_alternative_sectors',
				type: 'item',
				url: 'alternative-sectors',
				permissions: ['alternative_sectors.view'],
			},
		],
	},

	// Coorti
	{
		id: 'cohorts-section',
		title: 'Coorti',
		translate: 'menu_cohorts_section',
		type: 'collapsible',
		icon: 'users-rectangle',
		children: [
			{
				id: 'cohorts',
		title: 'Coorti',
		translate: 'menu_cohorts',
				type: 'item',
				url: 'cohorts',
				permissions: ['cohorts.view'],
			},
			{
				id: 'area-starts',
		title: 'Accessi',
		translate: 'menu_area_starts',
				type: 'item',
				url: 'area-starts',
				permissions: ['area_starts.view'],
			},
		],
	},

	// Utenti
	{
		id: 'users-section',
		title: 'Utenti',
		translate: 'menu_users_section',
		type: 'collapsible',
		icon: 'users',
		children: [
			{
				id: 'users',
		title: 'Utenti',
		translate: 'menu_users',
				type: 'item',
				url: 'users',
				permissions: ['users.view'],
			},
			{
				id: 'admin-roles',
		title: 'Gestione Ruoli',
		translate: 'menu_admin_roles',
				type: 'item',
				url: 'admin/roles',
				permissions: ['admin_roles.view'],
			},
			{
				id: 'admin-users',
		title: 'Gestione Ruoli Utenti',
		translate: 'menu_admin_users',
				type: 'item',
				url: 'admin/users',
				permissions: ['admin_users.view'],
			},
			{
				id: 'profiles',
		title: 'Tipologia Profili',
		translate: 'menu_profiles',
				type: 'item',
				url: 'profiles',
				permissions: ['profiles.view'],
			},
		],
	},

	// Strutture
	{
		id: 'facilities',
		title: 'Strutture',
		translate: 'menu_facilities',
		type: 'collapsible',
		icon: 'hospital',
		children: [
			{
				id: 'hospital-companies',
		title: 'Aziende - Sovrastrutture',
		translate: 'menu_hospital_companies',
				type: 'item',
				url: 'hospital-companies',
				permissions: ['hospital_companies.view'],
			},
			{
				id: 'hospital-locations',
		title: 'Presidi - Istituti',
		translate: 'menu_hospital_locations',
				type: 'item',
				url: 'hospital-locations',
				permissions: ['hospital_locations.view'],
			},
			{
				id: 'operational-units',
		title: 'Unità Operative - Strutture Scientifiche',
		translate: 'menu_operational_units',
				type: 'item',
				url: 'operational-units',
				permissions: ['operational_units.view'],
			},
			{
				id: 'operational-unit-types',
		title: 'Tipologie Convenzioni - Contratti',
		translate: 'menu_operational_unit_types',
				type: 'item',
				url: 'operational-unit-types',
				permissions: ['operational_unit_types.view'],
			},
		],
	},

	// Attività
	{
		id: 'activities-section',
		title: 'Attività',
		translate: 'menu_activities_section',
		type: 'collapsible',
		icon: 'book',
		children: [
			{
				id: 'activities',
		title: 'Attività pratiche e di tirocinio (professionalizzanti)',
		translate: 'menu_activities',
				type: 'item',
				url: 'activities',
				permissions: ['activities.view'],
			},
			{
				id: 'lessons',
		title: 'Didattica frontale (non professionalizzanti - lezioni pratiche)',
		translate: 'menu_lessons',
				type: 'item',
				url: 'lessons',
				permissions: ['lessons.view'],
			},
			{
				id: 'formal-teachings',
		title: 'Didattica Formale',
		translate: 'menu_formal_teachings',
				type: 'item',
				url: 'formal-teachings',
				permissions: ['formal_teachings.view'],
			},
			{
				id: 'combo-titles',
		title: 'Dettagli attività',
		translate: 'menu_combo_titles',
				type: 'item',
				url: 'combo-titles',
				permissions: ['combo_titles.view'],
			},
			// {
			// 	id: 'combo-items',
			// 	title: 'Opzioni Combo',
			// 	type: 'item',
			// 	url: 'combo-items',
			// },
			{
				id: 'autonomies',
		title: 'Autonomie',
		translate: 'menu_autonomies',
				type: 'item',
				url: 'autonomies',
				permissions: ['autonomies.view'],
			},
			{
				id: 'cfu-types',
		title: 'Tipologie CFU',
		translate: 'menu_cfu_types',
				type: 'item',
				url: 'cfu-types',
				permissions: ['cfu_types.view'],
			},
		],
	},

	// Carriera
	{
		id: 'career',
		title: 'Carriera',
		translate: 'menu_career',
		type: 'collapsible',
		icon: 'graduation-cap',
		children: [
			{
				id: 'suspensions',
		title: 'Tipologie sospensive',
		translate: 'menu_suspensions',
				type: 'item',
				url: 'suspension-reasons',
				permissions: ['suspension_reasons.view'],
			},
		],
	},

	// Obiettivi
	{
		id: 'totalizers-section',
		title: 'Obiettivi',
		translate: 'menu_totalizers_section',
		type: 'collapsible',
		icon: 'bullseye',
		children: [
			{
				id: 'tot',
		title: 'Obiettivi',
		translate: 'menu_totalizers',
				type: 'item',
				url: 'totalizers',
				permissions: ['totalizers.view'],
			},
			{
				id: 'school-totalizer',
		title: 'Obiettivi Scuole',
		translate: 'menu_school_totalizers',
				type: 'item',
				url: 'totalizers-schools',
				permissions: ['school_totalizers.view'],
			},
			{
				id: 'activities-totalizers',
		title: 'Obiettivi Attività Professionalizzanti',
		translate: 'menu_activities_totalizers',
				type: 'item',
				url: 'totalizers-activities',
				permissions: ['activity_totalizers.view'],
			},
		],
	},

	// Report
	{
		id: 'reports-section',
		title: 'Report',
		translate: 'menu_reports_section',
		type: 'collapsible',
		icon: 'file-alt',
		children: [
			{
				id: 'my-reports',
		title: 'I miei Report',
		translate: 'menu_my_reports',
				type: 'item',
				url: 'my-reports',
			},
			{
				id: 'admin-reports-queue',
		title: 'Coda Report',
		translate: 'menu_admin_reports_queue',
				type: 'item',
				url: 'admin/reports-queue',
				permissions: ['admin_reports.view'],
			},
		],
	},

	// Personalizzazioni
	{
		id: 'configurations-section',
		title: 'Impostazioni',
		translate: 'menu_configurations_section',
		type: 'collapsible',
		icon: 'sliders-h',
		children: [
			{
				id: 'admin-university-customizations',
		title: 'Personalizzazioni Ateneo',
		translate: 'menu_admin_university_customizations',
				type: 'item',
				icon: 'sliders-h',
				url: 'admin/university-customizations',
				permissions: ['admin_university_customizations.view'],
			},
			{
				id: 'admin-university-configurations',
		title: 'Configurazioni Ateneo',
		translate: 'menu_admin_university_configurations',
				type: 'item',
				icon: 'cog',
				url: 'admin/university-configurations',
				permissions: ['admin_university_configurations.view'],
			},
			{
				id: 'admin-university-cineca',
		title: 'Cineca',
		translate: 'menu_admin_university_cineca',
				type: 'item',
				icon: 'database',
				url: 'admin/cineca',
				permissions: ['university_cineca.view'],
			},
		],
	},

	// Admin Communications
	{
		id: 'admin-communications',
		title: 'Log Comunicazioni',
		translate: 'menu_admin_communications',
		type: 'item',
		icon: 'envelope',
		url: 'admin/communications',
		permissions: ['admin_communications.view'],
	},

	// Scheduler
	{
		id: 'admin-scheduler',
		title: 'Scheduler',
		translate: 'menu_admin_scheduler',
		type: 'item',
		icon: 'clock',
		url: 'admin/scheduler',
		permissions: ['admin_scheduler.view'],
	},
];
